export default "__VITE_ASSET__DO5V504Q__"